import styles from "./index.module.css";
import "./index.css";

import React, {useEffect, useState} from 'react';
import {components} from "react-select";
import {get, set, forOwn, omit} from "lodash";
import {SelectDynamicValueFunction} from 'Core/components/input/SelectInput';
import NumberLabel from 'Core/components/display/NumberLabel';
import {getNumber, getObject, getString} from 'Core/helpers/data';
import {getTranslation, i18nEffect, translate} from 'Core/i18n';
import {CUSTOMER_GROUP_STATUS, CUSTOMER_GROUP_STATUS_COLOR_CLASS} from 'Pages/apps/default/customerGroups/const';
import Icon from 'Core/components/display/Icon';

/**
 * Select single value replacement component using Label component
 * @description Use this as an SingleValue component replacement for the SelectInput (react-select) component. You can 
 * pass Label component props through the 'singleValueProps' prop of the SelectInput component. These props can be an 
 * instance of SelectDynamicValueFunction class if the prop should depend on option data.
 *
 * @param {Object} - Single value props sent by the react-select component to all the single values.
 * @return {JSX.Element}
 * @constructor
 */
const CountSingleValueComponent = ({children, ...props}) => {
	// Define component's translation path.
	const translationPath = 'CustomerGroupSelectInput';

	// Use 'i18nEffect' function in React 'useEffect' function to update (re-render) component when translation changes.
	const i18nEffectHook = i18nEffect.bind(null, useState(getTranslation())[1]);
	useEffect(() => { i18nEffectHook(); }, [i18nEffectHook]);
	
	const singleValueProps = get(props, 'selectProps.singleValueProps', {});

	// If any prop is an instance of SelectDynamicValueFunction class, call the inner func and pass the option data to it 
	// to get the actual value
	let labelComponentProps = {};
	forOwn(singleValueProps, (value, key) => {
		if (value instanceof SelectDynamicValueFunction) {
			try { set(labelComponentProps, key, value.func(props.data)); }
			catch (e) { omit(labelComponentProps, [key]); }
		}
		else set(labelComponentProps, key, value);
	});
	const customerCount = getNumber(props, 'data.customerCount');
	const status = getString(props, 'data.status');
	const inactive = (status !== CUSTOMER_GROUP_STATUS.ACTIVE);

	return (
		<components.SingleValue {...props}>
			<div className={`${styles['wrapper']} ${inactive ? styles['inactive'] : ''}`}>
				<div className={styles['label']}>
					<Icon 
						symbol="circle" 
						className={`customer-group-status-icon ${CUSTOMER_GROUP_STATUS_COLOR_CLASS[status]}`} 
					/>{children}
				</div>
				<NumberLabel
					{...labelComponentProps}
					element="div"
					elementProps={{
						...getObject(labelComponentProps, 'elementProps'),
						className: `${getString(labelComponentProps, 'elementProps.className')} ${styles['count']}`
					}}
					prefix={translate('customers_count_prefix', translationPath)}
					number={customerCount}
				/>
			</div>
		</components.SingleValue>
	)
};

export default CountSingleValueComponent;